import { registerLanguage } from '../_.contribution.js';

registerLanguage({
  id: "sparql",
  extensions: [".rq"],
  aliases: ["sparql", "SPARQL"],
  loader: () => import('./sparql.js')
});
